/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type AboveValueConfigKind = (typeof AboveValueConfigKind)[keyof typeof AboveValueConfigKind];

export const AboveValueConfigKind = {
  above: 'above',
} as const;
